// extracted by mini-css-extract-plugin
export var integrationButton = "_64-0";